import React from 'react';
import {
  HeroBanner,
  HeroBannerProps,
  TextColorMode,
} from '@noths/polaris-client-ribbons-design-system';
import parse from 'html-react-parser';

import { trackLinkClick } from '../../../tracking/common/banner';
import { trackImpression } from '../../../tracking/common/trackImpression';
import { TrackingContext } from '../../../types/TrackingContext';
import { BlockContainer } from '../BlockContainer';
import * as styles from './HeroBannerBlock.style';

const parseOptionalHtmlString = (html: string) => {
  const reactNodes = parse(html);
  return !Array.isArray(reactNodes) ? reactNodes : undefined;
};

export interface HeroBannerBlockProps extends HeroBannerProps {
  trackingTitle: string;
  trackingPosition?: number;
  subHeading?: string;
  copy?: string;
}

export const HeroBannerBlock = ({
  copy,
  subHeading,
  trackingPosition,
  trackingTitle,
  ...restOfProps
}: HeroBannerBlockProps) => {
  const trackingContext: TrackingContext = {
    trackingPosition,
    trackingTitle,
    trackingContentType: 'Hero banner',
  };

  return (
    <BlockContainer wrapperStyles={styles.wrapper}>
      <HeroBanner
        subHeading={subHeading && parseOptionalHtmlString(subHeading)}
        copy={copy && parseOptionalHtmlString(copy)}
        onVisible={() => trackImpression(trackingContext)}
        onButtonClick={(e: React.MouseEvent<HTMLAnchorElement>) =>
          trackLinkClick(e, trackingContext, 'CTA')
        }
        onLinkClick={(e: React.MouseEvent) => trackLinkClick(e, trackingContext, 'Link')}
        {...restOfProps}
      />
    </BlockContainer>
  );
};

export type { HeroBannerProps, TextColorMode };
